/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';
import _ from 'lodash';
import $ from'jquery';
import reviewObj from '../../objects/reviewObj';


class workflowModalModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("helpModal");
        this.context = context;
        this.id = ko.observable(this.context.util.guid());

        this.helpHtml = ko.observable();
        this.helpTitle = ko.observable();
        this.helpTitleCss = ko.observable();

        context.eventManager.subscribe((helpObj) =>{
            console.log("event: show-help-modal");
            this.updateHelpModal(helpObj);
        },this, "show-help-modal");


    }

    updateHelpModal(helpObj) {
        
        this.helpHtml(helpObj.helpHtml);
        this.helpTitle(helpObj.helpTitle);
        this.helpTitleCss(helpObj.helpTitleCss);

        $('#helpModal').modal('show');
    }


}

export default { viewModel: workflowModalModel, template: require('!raw-loader!./help-modal.html') };


// WEBPACK FOOTER //
// ./src/components/help-modal/help-modal.js